export const BASE_URL = "https://admin.graha.studio/api/";
export const BASE_IMG_URL = "https://admin.graha.studio/";